import { Pipe, PipeTransform } from "@angular/core";

/** Millisecond epoch (number or numeric string). */
function toDate(value: string | number | Date): Date | null {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (/^\d+$/.test(trimmed)) {
      const n = Number(trimmed);
      if (!Number.isFinite(n)) {
        return null;
      }
      const d = new Date(n);
      return Number.isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(trimmed);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

@Pipe({
  name: "romeDate",
})
export class RomeDatePipe implements PipeTransform {
  transform(
    value: string | number | Date | null | undefined,
    format = "dd/MM/yyyy HH:mm:ss",
    timeZone = "Europe/Rome",
    locale = "it-IT"
  ): string {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    const date = toDate(value);
    if (!date) {
      return "";
    }

    // Legacy templates used Angular's YYYY; we only support yyyy
    const normalizedFormat = format.replace(/YYYY/g, "yyyy");

    const dateParts = new Intl.DateTimeFormat(locale, {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).formatToParts(date);

    const partsMap = dateParts.reduce<Record<string, string>>((acc, part) => {
      if (part.type !== "literal") {
        acc[part.type] = part.value;
      }
      return acc;
    }, {});

    const tokens: Record<string, string> = {
      yyyy: partsMap["year"] ?? "",
      MM: partsMap["month"] ?? "",
      dd: partsMap["day"] ?? "",
      HH: partsMap["hour"] ?? "",
      mm: partsMap["minute"] ?? "",
      ss: partsMap["second"] ?? "",
    };

    return normalizedFormat.replace(/yyyy|MM|dd|HH|mm|ss/g, (token) => tokens[token] ?? token);
  }
}
